import noop from "lodash/noop";
import PropTypes from "prop-types";
import styled from "styled-components";
import React from "react";
import {Link} from "react-router-dom";
import s from "./BlogPostPreviewAuthor.pcss";
import {getenv} from "../../../../util/getEnv";

const AuthorTitleName = styled.div`
    font-size: 1rem;
    line-height: 1.375rem;
    color: ${({theme}) => theme.colors.universityColor};
`;

const AuthorProfileLink = styled(Link)`
    color: ${({theme}) => theme.colors.universityColor};
    text-decoration: underline ${({theme}) => theme.colors.universityColor};
    display: flex;
    padding: 15px;
`;

const AuthorTitleDegree = styled.div`
    font-size: 0.875rem;
    line-height: 1.375rem;
    color: ${({theme}) => theme.colors.universityColor};
`;

const BlogPostPreviewAuthor = (props) => {
    const DEFAULT_PROFILE_PHOTO = getenv("DEFAULT_PROFILE_PHOTO");
    const image = (
        <img
            data-test-id="blog-author-image"
            className={s.authorImage}
            src={props.profilePhoto || DEFAULT_PROFILE_PHOTO}
            alt="Profile"
        />
    );

    const degree = <AuthorTitleDegree>{props.degreeName}</AuthorTitleDegree>;

    if (props.shouldLinkToProfile) {
        return (
            <AuthorProfileLink onClick={props.onSelectAuthor} to={props.authorUrl}>
                <div className={s.authorImageContainer}>{image}</div>
                <div className={s.authorTitle}>
                    <AuthorTitleName>
                        <h2
                            data-test-id="blog-author-name"
                            aria-label={`Blog by ${props.firstName}`}
                        >
                            {props.firstName}
                        </h2>
                    </AuthorTitleName>
                    {degree}
                </div>
            </AuthorProfileLink>
        );
    }

    return (
        <div className={s.container}>
            <div className={s.authorImageContainer}>{image}</div>
            <div className={s.authorTitle}>
                <AuthorTitleName>
                    <h2 data-test-id="blog-author-name" aria-label={`Blog by ${props.firstName}`}>
                        {props.firstName}
                    </h2>
                </AuthorTitleName>
                {degree}
            </div>
        </div>
    );
};

BlogPostPreviewAuthor.propTypes = {
    profilePhoto: PropTypes.string,
    authorUrl: PropTypes.string,
    firstName: PropTypes.string,
    degreeName: PropTypes.string,
    shouldLinkToProfile: PropTypes.bool,
    onSelectAuthor: PropTypes.func,
};

BlogPostPreviewAuthor.defaultProps = {
    profilePhoto: "",
    authorUrl: "",
    firstName: "",
    degreeName: "",
    shouldLinkToProfile: false,
    onSelectAuthor: noop,
};

export default BlogPostPreviewAuthor;
